import styled from "styled-components"

export const Text = styled.p`
  margin: 0;
  font-size: 25px;
  font-weight: 700;
  color: ${props => props.theme.dropStatusTextColor};
`